import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { SnapshotsSection } from '@/features/reports/snapshots'

/** Freezing a report as at a date, and browsing what has already been frozen. */
export function ReportsSnapshotsPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Report snapshots"
        description="Freeze a report as at a date so its figures cannot move afterwards, and read one back with its integrity hash."
      />

      <SnapshotsSection />
    </>
  )
}
